export const packagingTypes = [
    {
        value: "1",
        label: "Παλέτα",
    },
    {
        value: "2",
        label: "Κούτα",
    },
    {
        value: "3",
        label: "Κιβώτιο",
    },
    {
        value: "4",
        label: "Βαρέλι",
    },
    {
        value: "5",
        label: "Σάκος",
    },
    {
        value: "6",
        label: "Λοιπά",
    },
]
